export default __webpack_public_path__ + "static/how-to-design_final-9c139cfc7f624551e873bbca41cf18c6.png";